<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar rounede dense color="indigo" flat>
        <v-toolbar-title class="white--text">
          Scarti di Produzione
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- Input della data da -->
        <v-menu
          v-model="calendario_data_da"
          :close-on-content-click="false"
          :nudge-right="40"
          min-width="289"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div
              class="mr-5"
              style="
                border: 1px solid black;
                display: inline-block;
                background-color: white;
                padding: 3px;
              "
            >
              <v-text-field
                background-color="#ffffff"
                class="custom-label-color"
                color="white"
                dense
                hide-details
                label="Data Da"
                v-model="data_da_formattata"
                readonly
                style="max-width: 100px"
                v-on="on"
              >
              </v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="data_da"
            @input="calendario_data_da = false"
          ></v-date-picker>
        </v-menu>

        <!-- Input della data a -->
        <v-menu
          v-model="calendario_data_a"
          :close-on-content-click="false"
          :nudge-right="40"
          min-width="289"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div
              class="mr-5"
              style="
                border: 1px solid black;
                display: inline-block;
                background-color: white;
                padding: 3px;
              "
            >
              <v-text-field
                background-color="#ffffff"
                class="custom-label-color"
                color="white"
                dense
                hide-details
                label="Data A"
                v-model="data_a_formattata"
                readonly
                style="max-width: 100px"
                v-on="on"
              >
              </v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="data_a"
            @input="calendario_data_a = false"
          ></v-date-picker>
        </v-menu>

        <!-- Bottone della ricerca -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="getMovimentiScarto"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-magnify </v-icon>
            </v-btn>
          </template>
          <span>Cerca</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="clickAggiungiScarti" small v-bind="attrs" v-on="on">
              <v-icon color="primary"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Aggiungi</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        <v-btn
          class="red--text"
          @click="clickChiudi"
          color="blue-grey lighten-5"
          small
        >
          <v-icon>mdi-keyboard-backspace</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row align="center" justify="center">
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_causali_scarto_totali"
              item-text="cod_commessa"
              item-value="cod_commessa"
              label="Cod Commessa"
              style="display: inline-block; max-width: 350px"
              v-model="cod_commessa_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_commessa_search = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_commessa_search == null
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="
                items_causali_scarto_totali.filter(
                  (e) => e.cod_macchina != null && e.cod_macchina != ''
                )
              "
              item-text="cod_macchina"
              item-value="cod_macchina"
              label="Cod. Macchina"
              style="display: inline-block; max-width: 350px"
              v-model="cod_macchina_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_macchina_search = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_macchina_search == null
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_causali_scarto_totali"
              item-text="nominativo"
              item-value="nominativo"
              label="Nome Operatore"
              style="display: inline-block; max-width: 350px"
              v-model="nome_operatore_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    nome_operatore_search = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    nome_operatore_search == null
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_causali_scarto_totali.filter((e) => e.data != null)"
              :item-text="(e) => e.data.substr(0, 10)"
              item-value="data_js"
              label="Data"
              style="display: inline-block; max-width: 350px"
              v-model="dalla_data"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    dalla_data = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    dalla_data == null ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="
                items_causali_scarto_totali.filter((e) => e.quantita != null)
              "
              item-text="quantita"
              item-value="quantita"
              label="Quantità"
              style="display: inline-block; max-width: 350px"
              v-model="quantita_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    quantita_search = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    quantita_search == null ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>

        <!-- Tabella dei dati -->
        <v-data-table
          class="elevation-1"
          :headers="header_causali_scarto"
          height="70vh"
          :items="items_causali_scarto"
        >
          <!-- Bottone di modifica delle dichiarazioni -->
          <template v-slot:[`item.modifica`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  @click="clickModificaRiga(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-pencil </v-icon>
                </v-btn>
              </template>
              <span>Modifica Dichiarazione</span>
            </v-tooltip>
          </template>

          <!-- Colonna della data -->
          <template v-slot:[`item.data`]="{ item }">
            {{
              item.data != null && item.data != undefined && item.data != ""
                ? formatData(item.data, "full")
                : "N/D"
            }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="rettifica_dialog" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Rettifica Scarto
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaRettifica" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiRettificaDialog"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-row align="center" justify="center">
            <v-col cols="6" align="center">
              <v-text-field
                dense
                hide-details
                label="Q.tà Scarti"
                style="max-width: 150px"
                type="number"
                v-model="riga_sel.quantita"
              ></v-text-field>
            </v-col>
            <v-col cols="6" align="center">
              <v-autocomplete
                dense
                hide-details
                :items="items_causali"
                item-text="des"
                item-value="id_tabella"
                label="Causale"
                style="max-width: 150px"
                v-model="riga_sel.id_causale"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di aggiunta riga pezzi -->
    <v-dialog v-model="dialog_aggiungi_scarti" persistent width="unset">
      <v-card style="max-width: 900px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Aggiunta Riga Scarti {{ id_commessa_tmp }}
            {{ id_commessa_dettaglio_tmp }}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaRigaScarti" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Riga</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  dialog_aggiungi_scarti = false;
                  this.items_fasi_selezionabili = new Array();
                  this.items_tempi_selezionabili = new Array();
                  this.items_selezione_lotto = new Array();
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Cod. Articolo"
                  readonly
                  v-model="cod_articolo_tmp"
                >
                  <!--<template v-slot:append-outer>
                    <v-btn @click="cercaArticoli" small>
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>-->
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  @keydown.enter="cercaCommesse"
                  label="Cod. Commessa"
                  v-model="cod_commessa_tmp"
                >
                  <template v-slot:append-outer>
                    <v-btn @click="cercaCommesse" small>
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_fasi_selezionabili"
                  item-text="cod_fase"
                  item-value="id_commessa_dettaglio"
                  label="Cod. Fase"
                  v-model="id_commessa_dettaglio_tmp"
                >
                </v-autocomplete>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  @keydown.enter="cercaLotti"
                  label="Cod. Lotto"
                  v-model="cod_lotto_tmp"
                >
                  <template v-slot:append-outer>
                    <v-btn @click="cercaLotti" small>
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Quantita"
                  v-model.number="quantita_tmp"
                  type="number"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_causali"
                  item-text="des"
                  item-value="id_tabella"
                  label="Causale"
                  v-model="id_causale_tmp"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Start"
                  readonly
                  v-model="start_tmp_formattato"
                >
                </v-text-field>
              </v-col>

              <v-col class="my-0" justify="center" cols="3">
                <v-text-field
                  dense
                  hide-details
                  label="Stop"
                  readonly
                  v-model="stop_tmp_formattato"
                >
                </v-text-field>
              </v-col>

              <v-col cols="3" align="start" justify="center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="clickSelezionaTempi"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                  <span>Ricerca Tempi</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di selezione dell'articolo -->
    <!--<v-dialog v-model="dialog_seleziona_articolo" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Articolo
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_seleziona_articolo = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_selezione_articolo"
                  :items="items_selezione_articolo"
                >
                  <template v-slot:[`item.selezione`]="{ item }">
                    <v-btn @click="selezionaArticolo(item)" small>
                      <v-icon color="success">
                        mdi-check
                      </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>-->

    <!-- Dialog di selezione della commessa -->
    <v-dialog v-model="dialog_seleziona_commessa" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Commessa
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_seleziona_commessa = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_selezione_commessa"
                  :items="items_selezione_commessa"
                >
                  <template v-slot:[`item.selezione`]="{ item }">
                    <v-btn @click="selezionaCommessa(item)" small>
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di selezione del lotto -->
    <v-dialog v-model="dialog_seleziona_lotto" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Lotto
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_seleziona_lotto = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_selezione_lotto"
                  :items="items_selezione_lotto"
                >
                  <template v-slot:[`item.selezione`]="{ item }">
                    <v-btn @click="selezionaLotto(item)" small>
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di selezione del tempo di produzione -->
    <v-dialog v-model="dialog_seleziona_tempi" width="unset">
      <v-card style="max-width: 800px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Tempo di Produzione
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_seleziona_tempi = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="4">
                <v-menu
                  v-model="calendario_tempi_data_da"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      hide-details
                      label="Data Da"
                      v-model="tempi_data_da_formattata"
                      readonly
                      style="max-width: 150px"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="tempi_data_da"
                    @input="calendario_tempi_data_da = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="4">
                <v-menu
                  v-model="calendario_tempi_data_a"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      hide-details
                      label="Data A"
                      v-model="tempi_data_a_formattata"
                      readonly
                      style="max-width: 150px"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="tempi_data_a"
                    @input="calendario_tempi_data_a = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="getTempi" small v-bind="attrs" v-on="on">
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                  <span>Ricerca Tempi</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_tempi_selezionabili"
                  :items="
                    items_tempi_selezionabili.filter(
                      (e) =>
                        e.id_commessa == id_commessa_tmp &&
                        e.id_commessa_dettaglio == id_commessa_dettaglio_tmp
                    )
                  "
                >
                  <template v-slot:[`item.selezione`]="{ item }">
                    <v-btn @click="selezionaTempo(item)" small>
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:[`item.ora_inizio`]="{ item }">
                    {{ formatData(item.ora_inizio, "full") }}
                  </template>

                  <template v-slot:[`item.ora_fine`]="{ item }">
                    {{ formatData(item.ora_fine, "full") }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Loader -->
    <v-overlay :value="overlay" z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Riga {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "cod_commessa", default_val: "" },
      { nome: "cod_fase", default_val: "" },
      { nome: "cod_macchina", default_val: "" },
      { nome: "date_ins", default_val: "" },
      { nome: "des_fase", default_val: "" },
      { nome: "id_causale", default_val: null },
      { nome: "id_commessa_causale", default_val: -1 },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "id_utente", default_val: null },
      { nome: "id_personale", default_val: null },
      { nome: "nominativo", default_val: "" },
      { nome: "pezzi", default_val: 0 },
      { nome: "tipo_causale", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "TabellaScarti",
  components: { SnackbarQV },
  props: {
    visible: { type: Boolean, default: false },
  },
  computed: {
    data_a_formattata() {
      return this.data_a != "" ? moment(this.data_a).format("DD/MM/YYYY") : "";
    },
    data_da_formattata() {
      return this.data_da != ""
        ? moment(this.data_da).format("DD/MM/YYYY")
        : "";
    },
    dalla_data_search() {
      return this.dalla_data
        ? moment(
            `${this.dalla_data.substr(6, 4)}-${this.dalla_data.substr(
              3,
              2
            )}-${this.dalla_data.substr(0, 2)}`
          )
        : null;
    },
    start_tmp_formattato() {
      return this.start_tmp != ""
        ? moment(this.start_tmp).format("DD/MM/YYYY HH:mm:ss")
        : "";
    },
    stop_tmp_formattato() {
      return this.stop_tmp != ""
        ? moment(this.stop_tmp).format("DD/MM/YYYY HH:mm:ss")
        : "";
    },
    tempi_data_a_formattata() {
      return this.tempi_data_a != ""
        ? moment(this.tempi_data_a).format("DD/MM/YYYY")
        : "";
    },
    tempi_data_da_formattata() {
      return this.tempi_data_da != ""
        ? moment(this.tempi_data_da).format("DD/MM/YYYY")
        : "";
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      cod_articolo_tmp: "",
      cod_commessa_search: null,
      cod_commessa_tmp: "",
      cod_fase_tmp: "",
      cod_lotto_tmp: "",
      cod_macchina_search: null,
      dalla_data: null,
      data_a: null,
      data_da: null,
      des_causale_tmp: "",
      id_articolo_tmp: null,
      id_causale_tmp: null,
      id_commessa_tmp: null,
      id_commessa_dettaglio_tmp: null,
      id_commessa_tempi_tmp: null,
      id_commessa_movimenti_tmp: null,
      id_lotto_tmp: null,
      id_magazzino_scarto: null,
      limite_mesi_passati: 0,
      nome_operatore_search: null,
      quantita_search: null,
      quantita_tmp: null,
      riga_sel: new Riga(),
      start_tmp: "",
      stop_tmp: "",
      tempi_data_a: "",
      tempi_data_da: "",

      // Modal
      calendario_data_a: false,
      calendario_data_da: false,
      calendario_tempi_data_a: false,
      calendario_tempi_data_da: false,
      dialog_aggiungi_scarti: false,
      dialog_seleziona_articolo: false,
      dialog_seleziona_commessa: false,
      dialog_seleziona_lotto: false,
      dialog_seleziona_tempi: false,
      overlay: false,
      rettifica_dialog: false,

      // Array
      header_causali_scarto: [
        { text: "Modifica", value: "modifica", sortable: false },
        { text: "Cod. Commessa", value: "cod_commessa" },
        { text: "Cod. Fase", value: "cod_fase" },
        { text: "Des. Fase", value: "des_fase" },
        { text: "Cod. Macchina", value: "cod_macchina" },
        { text: "Data", value: "data" },
        { text: "Nominativo", value: "nominativo" },
        { text: "Causale", value: "causale" },
        { text: "Q.tà Scarti", value: "quantita" },
      ],
      headers_selezione_articolo: [
        { text: "Selezione", value: "selezione", sortable: false },
        { text: "Cod. Articolo", value: "cod_articolo", sortable: false },
      ],
      headers_selezione_commessa: [
        { text: "Selezione", value: "selezione", sortable: false },
        { text: "Cod. Commessa", value: "cod", sortable: false },
      ],
      headers_selezione_lotto: [
        { text: "Selezione", value: "selezione", sortable: false },
        { text: "Cod. Lotto", value: "cod_lotto", sortable: false },
      ],
      headers_tempi_selezionabili: [
        {
          text: "Selezione",
          sortable: false,
          value: "selezione",
        },
        {
          text: "Start",
          sortable: false,
          value: "ora_inizio",
        },
        {
          text: "Stop",
          sortable: false,
          value: "ora_fine",
        },
        {
          text: "Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Fase",
          sortable: false,
          value: "cod_fase",
        },
      ],
      items_causali: new Array(),
      items_causali_scarto: [],
      items_causali_scarto_totali: [],
      items_fasi_selezionabili: new Array(),
      items_selezione_articolo: new Array(),
      items_selezione_commessa: new Array(),
      items_selezione_lotto: new Array(),
      items_tempi_selezionabili: new Array(),
    };
  },
  methods: {
    cercaArticoli() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.user_token,
          id_articolo: this.id_articolo_tmp,
        },
      };

      // Se c'è, metto anche il cod_articolo.
      if (this.cod_articolo_tmp != null && this.cod_articolo_tmp != "") {
        request.richiesta.cod_articolo = this.cod_articolo_tmp;
      }

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (res.data.articolo) {
              this.id_articolo_tmp = res.data.articolo[0].id_articolo;
              this.cod_articolo_tmp = res.data.articolo[0].cod_articolo;
              this.$refs.SnackbarQV.print(
                "success",
                "Articolo selezionato con successo."
              );
            } else if (res.data.lista.length > 0) {
              this.items_selezione_articolo = res.data.lista;
              this.dialog_seleziona_articolo = true;
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Nessuna commessa corrisponde alla ricerca."
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    cercaCommesse() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessa",
          token: localStorage.user_token,
          cod_commessa: this.cod_commessa_tmp,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (res.data.lista.length === 1) {
              this.id_commessa_tmp = res.data.lista[0].id_commessa;
              this.cod_commessa_tmp = res.data.lista[0].cod;
              this.getFasiCommessa();
            } else if (res.data.lista.length > 0) {
              this.items_selezione_commessa = res.data.lista;
              this.dialog_seleziona_commessa = true;
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Nessuna commessa corrisponde alla ricerca."
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    cercaLotti() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getlotti",
          token: localStorage.user_token,
          cod_lotto: this.cod_lotto_tmp,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (res.data.length === 1) {
              this.id_lotto_tmp = res.data[0].id_lotto;
              this.cod_lotto_tmp = res.data[0].cod_lotto;
              this.$refs.SnackbarQV.print("success", "Lotto registrato.");
            } else if (res.data.length > 0) {
              this.items_selezione_lotto = res.data;
              this.dialog_seleziona_lotto = true;
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Nessuna commessa corrisponde alla ricerca."
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    checkModificaConsentita(arg) {
      /* Se il limite dei mesi passati è 0 vuol dire che
       * non l'ho impostato, quindi ritorno sempre true. */
      if (this.limite_mesi_passati == 0) {
        return true;
      }

      let data = moment(arg);
      let terminus_ante_quem = moment(
        `${parseInt(
          moment().subtract(this.limite_mesi_passati, "months").format("YYYY")
        )}-${parseInt(
          moment().subtract(this.limite_mesi_passati, "months").format("M")
        )}-01`
      );

      /* Ritorno true solo se la data passata è successiva
       * ad "adesso" meno il limite temporale consentito. */
      return data.isSameOrAfter(terminus_ante_quem);
    },
    chiudiRettificaDialog() {
      this.rettifica_dialog = false;
    },
    clickAggiungiScarti() {
      this.dialog_aggiungi_scarti = true;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickModificaRiga(arg) {
      let is_modifica_consentita = this.checkModificaConsentita(
        `${arg.data.split("T")[0].split("-")[0]}-${arg.data.split("T")[0].split("-")[1]}-01`
      );

      if (!is_modifica_consentita) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Non è consentito modificare record così vecchi: il limite è ${
            this.limite_mesi_passati
          } ${this.limite_mesi_passati == 1 ? "mese" : "mesi"}.`
        );
        return;
      }

      this.riga_sel = new Riga(arg);
      this.rettifica_dialog = true;
    },
    clickSelezionaTempi() {
      this.dialog_seleziona_tempi = true;
    },
    filtra() {
      let items_scarti_tmp = [];
      this.items_causali_scarto_totali.forEach((elem) => {
        items_scarti_tmp.push(elem);
      });

      //Filtro il codice Commessa
      if (this.cod_commessa_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_scarti_tmp.forEach((elem) => {
          if (elem.cod_commessa == this.cod_commessa_search) {
            res.push(elem);
          }
        });
        items_scarti_tmp = res;
      }

      // Filtro il codice macchina
      if (this.cod_macchina_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_scarti_tmp.forEach((elem) => {
          if (elem.cod_macchina == this.cod_macchina_search) {
            res.push(elem);
          }
        });
        items_scarti_tmp = res;
      }

      // Filtro il nome dell'operatore
      if (this.nome_operatore_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_scarti_tmp.forEach((elem) => {
          if (elem.nominativo == this.nome_operatore_search) {
            res.push(elem);
          }
        });
        items_scarti_tmp = res;
      }

      // Filtro la data_da
      if (this.dalla_data_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_scarti_tmp.forEach((elem) => {
          if (elem.data_js.isSame(this.dalla_data_search)) {
            res.push(elem);
          }
        });
        items_scarti_tmp = res;
      }

      // Filtro la qualita
      if (this.quantita_search != null) {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_scarti_tmp.forEach((elem) => {
          if (elem.quantita == this.quantita_search) {
            res.push(elem);
          }
        });
        items_scarti_tmp = res;
      }
      this.items_causali_scarto = [];
      this.items_causali_scarto = items_scarti_tmp;
    },
    formatData(arg_data, arg_tipo = "full") {
      if (arg_data == null || arg_data == "") {
        return "N/D";
      } else {
        if (arg_tipo == "full") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          strRes += arg_data.substr(11, 8);
          return strRes;
        } else if (arg_tipo == "strict") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          return strRes;
        }
      }
    },
    getFasiCommessa() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessafull",
          token: localStorage.user_token,
          id_commessa: this.id_commessa_tmp,
          id_profilo: localStorage.id_profilo,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            res.data.commessa_dettaglio.forEach((f) => {
              f.cod_des_fase = `${f.cod_fase} - ${f.des}`;
            });

            this.items_fasi_selezionabili = res.data.commessa_dettaglio;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getMagazzinoScarto() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmagazzini",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            res.data.forEach((m) => {
              if (m.cod_magazzino === "SCARTO") {
                this.id_magazzino_scarto = m.id_magazzino;
              }
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getMovimentiScarto() {
      const data_a_tmp = this.data_a.substr(0, 10);
      const data_da_tmp = this.data_da.substr(0, 10);

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmovimentiscarto",
          token: localStorage.user_token,
          data_da: data_da_tmp,
          data_a: data_a_tmp,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.items_causali_scarto = res.data.result;
          this.items_causali_scarto_totali = res.data.result;
          this.filtra();
        })
        .catch((ex) => {
          this.items_causali_scarto = [];
          this.items_causali_scarto_totali = [];
          console.error(ex);
        });
    },
    getTabella() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.user_token,
          tipo: "PRODUZIONE_CAUSALI",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.causali = new Array();
            if (res.data) {
              this.items_causali = new Array();
              if (res.data.length > 0) {
                this.items_causali = res.data;
                return true;
              } else {
                return false;
              }
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati"
            );
            return false;
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati"
          );
        });
    },
    getTempi() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdatitempi",
          token: localStorage.user_token,
          start: this.tempi_data_da,
          stop: this.tempi_data_a,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_tempi_selezionabili = res.data.result.tempi;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getVincoliModifica() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
          codice: "CONSUNTIVI_SCARTI",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              return;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              return;
            }

            // Se l'array contiene informazioni per questo modulo, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "LIMITE_MESI_PASSATI"
              ).length > 0
            ) {
              this.limite_mesi_passati = res.data.result.filter(
                (e) => e.descrizione === "LIMITE_MESI_PASSATI"
              )[0].val_int;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    ripristinaFiltri() {
      this.cod_commessa_search = null;
      this.cod_macchina_search = null;
      this.dalla_data = null;
      this.nome_operatore_search = null;
      this.quantita_search = null;
      this.filtra();
    },
    salvaRettifica() {
      const riga_request = JSON.parse(JSON.stringify(this.riga_sel));
      riga_request.tipo_causale = 'SCARTO';
      riga_request.pezzi = riga_request.quantita;
      delete riga_request.date_ins;
      delete riga_request.id_commessa_tempi;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcausalicommessa",
          token: localStorage.user_token,
          tabella: [riga_request],
          flag_magazzino_movimenti: 0,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.rettifica_dialog = false;
            this.riga_sel = new Riga();

            // Stampo una snackbar di conferma
            this.$refs.SnackbarQV.print(
              "success",
              "Rettifica eseguita con successo."
            );

            // Aggiorno i dati
            this.getMovimentiScarto();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    salvaRigaScarti() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "addrigascarto",
          token: localStorage.user_token,
          movimenti: [
            {
              id_magazzino_magazzino: this.id_causale_tmp,
              data: this.stop_tmp,
              id_causale_magazzino: this.id_causale_tmp,
              id_articolo: this.id_articolo_tmp,
              cod_articolo: this.cod_articolo_tmp,
              des_articolo: this.des_articolo_tmp,
              id_magazzino: this.id_magazzino_scarto,
              id_commessa: this.id_commessa_tmp,
              id_commessa_dettaglio: this.id_commessa_dettaglio_tmp,
              id_commessa_tempi: this.id_commessa_tempi_tmp,
              id_commessa_movimenti: this.id_commessa_movimenti_tmp,
              quantita: this.quantita_tmp,
              id_lotto: this.id_lotto_tmp,
              cod_lotto: this.cod_lotto_tmp,
              validita: 1,
            },
          ],
          causali: [
            {
              id_causale: this.id_causale_tmp,
              id_commessa: this.id_commessa_tmp,
              id_commessa_causale: -1,
              id_commessa_dettaglio: this.id_commessa_dettaglio_tmp,
              id_commessa_movimenti: -1,
              id_commessa_tempi: this.id_commessa_tempi_tmp,
              pezzi: this.quantita_tmp,
              tipo_causale: "SCARTO",
              validita: 1,
              id_causali_produzione: -1,
              id_lotto: this.id_lotto_tmp,
              cod_lotto: this.cod_lotto_tmp,
            },
          ],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.dialog_aggiungi_scarti = false;

            this.start_tmp = "";
            this.stop_tmp = "";
            this.id_articolo_tmp = null;
            this.cod_articolo_tmp = "";
            this.id_commessa_tmp = null;
            this.cod_commessa_tmp = "";
            this.id_commessa_dettaglio_tmp = null;
            this.id_commessa_tempi_tmp = null;
            this.id_commessa_movimenti_tmp = null;
            this.cod_fase_tmp = "";
            this.id_causale_tmp = null;
            this.des_causale_tmp = "";
            this.quantita_tmp = null;
            this.id_lotto_tmp = null;
            this.cod_lotto_tmp = "";

            this.items_fasi_selezionabili = new Array();
            this.items_tempi_selezionabili = new Array();
            this.items_selezione_lotto = new Array();

            this.getMovimentiScarto();

            this.$refs.SnackbarQV.print(
              "success",
              "Scarto salvato con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    selezionaArticolo(arg) {
      this.id_articolo_tmp = arg.id_articolo;
      this.cod_articolo_tmp = arg.cod_articolo;
      this.dialog_seleziona_articolo = false;
    },
    selezionaCommessa(arg) {
      /* Registro l'articolo della commessa e ne cerco
       * il dettaglio per prendere il codice articolo. */
      this.id_articolo_tmp = arg.id_articolo;
      this.cercaArticoli();

      /* Registro id_commessa e codice commessa e
       * cerco le sue fasi per selezionarne una. */
      this.id_commessa_tmp = arg.id_commessa;
      this.cod_commessa_tmp = arg.cod;
      this.getFasiCommessa();

      this.dialog_seleziona_commessa = false;
    },
    selezionaLotto(arg) {
      this.id_lotto_tmp = arg.id_lotto;
      this.cod_lotto_tmp = arg.cod_lotto;
      this.dialog_seleziona_lotto = false;
    },
    selezionaTempo(arg) {
      this.start_tmp = arg.ora_inizio;
      this.stop_tmp = arg.ora_fine;
      this.id_commessa_tempi_tmp = arg.id_commessa_tempi;
      this.id_commessa_movimenti_tmp = arg.id_commessa_movimenti;

      this.dialog_seleziona_tempi = false;
      this.items_tempi_selezionabili = new Array();
    },
  },
  watch: {
    visible: {
      immediate: true,
      async handler() {
        if (this.visible === true) {
          this.data_a = moment().format("YYYY-MM-DD");
          this.data_da = moment().subtract(7, "days").format("YYYY-MM-DD");

          // Prendo le varie causali
          await this.getTabella();

          // Prendo il magazzino dello scarto.
          this.getMagazzinoScarto();

          /* Dopo aver preso le causali, prendo gli
           * oggetti da inserire in tabella e mentre
           * li colleziono gli monto dentro la
           * descrizione di causale corretta. */
          this.getMovimentiScarto();
        }
      },
    },
  },
  mounted() {
    this.getVincoliModifica();

    this.tempi_data_a = moment().format("YYYY-MM-DD");
    this.tempi_data_da = moment().subtract(7, "days").format("YYYY-MM-DD");
  },
};
</script>
<style scoped>
</style>